var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.sticky.box('body','scrolled', -1);
});
